import React from "react";
import logoSource from "../../images/baashyaam_logo.png";

function Logo(props) {
  return (
    <img
      width="170px"
      src={logoSource}
      alt="Baashyaam Group"
      {...props}
    />
  );
}

export default Logo;
